<template>
<div>
    <Header title="物流信息" />
    <div class="item" v-for="(item, index) in dataSources" :key="index">
        <div class="header">
            <div>
                <p>{{item.express_company}}</p>
                <span>{{item.express_no}}</span>
            </div>
            <p @click="_onPressToShowLogisticsInfo(item)">查看物流</p>
        </div>
        <div class="body">
            <div v-for="(_item, _index) in item.goods_info" :key="_index">
                <img :src="_item.goods_image" alt="">
                <div>
                    <p class="title">{{_item.goods_name}}</p>
                    <p class="unit">规格:{{_item.sku_field}}</p>
                    <div class="price">
                        <p>￥{{_item.price}}</p>
                        <span>×{{_item.sum}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <van-popup closeable v-model="isShowLogisticsInfo" round position="bottom" :style="{ height: '60%', paddingTop: '6rem'}">
        <div class="list-wrap h100 over-ys">
            <van-steps direction="vertical" :active="0">
                <van-step v-for="(item, index) in logistics_info.list" :key="index">
                    <h3>{{item.time}}</h3>
                    <p>{{item.status}}</p>
                </van-step>
            </van-steps>
        </div>
    </van-popup>

</div>
</template>

<script>
import Header from '@/components/Header'
export default {
    components: {
        'Header': Header,
    },
    data() {
        return {
            isShowLogisticsInfo: false,
            logistics_no: 73171473769778,
            dataSources: [],
            logistics_info: {},
        };
    },
    mounted() {
        this._initialSendRecordInfo();
    },
    methods: {
        onPressNav(router, query = {}) {
            this.$router.push({
                path: '/' + router,
                query: query
            })
        },

        _initialSendRecordInfo() {
            let _dataSourceTemp = this.Lockr.get('send_record');
            this.dataSources = _dataSourceTemp ? JSON.parse(_dataSourceTemp) : [];
            console.log('this.dataSources---->', this.dataSources);
        },

        _onPressToShowLogisticsInfo(item) {
            this._requestLogisticsInfo(item);
        },
        
        async _requestLogisticsInfo(item) {
            let url = this.API.logistics_detail;
            let data = {
                no: item.express_no,
            };
            let result = await this.$post(url, data);
            if (result.code == this.GLOBAL.SUCCESS_CODE) {
                this.logistics_info = result.data;
                this.isShowLogisticsInfo = true;
            }

        }
    },
};
</script>

<style lang="less" scoped>
.item {
    padding: 0px 15px 10px;

    .header {
        margin-top: 10px;
        height: 72px;
        padding: 0 15px;
        border-radius: 5px;
        background: #fff;
        display: flex;
        align-items: center;

        div {
            flex: 1;

            >p {
                font-size: 15px;
                color: #7485EB;
            }

            >span {
                font-size: 13px;
                color: #7485EB;
            }
        }

        >p {
            width: 67px;
            height: 28px;
            background: linear-gradient(205deg, #9cb2f4 1%, #9bb1f4 1%, #6472e8 84%);
            border-radius: 5px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 12px;
            color: #fff;
        }
    }

    .body {
        margin-top: 10px;
        padding: 0 10px 10px;
        background: #fff;
        border-radius: 5px;

        >div {
            display: flex;
            padding: 1rem 0;
            border-bottom: 1px dashed #ddd;

            &:last-of-type {
                border: 0;
            }

            >img {
                width: 80px;
                height: 80px;
                object-fit: cover;
                margin-right: 10px;
            }

            >div {
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                overflow: hidden;

                .title {
                    font-size: 14px;
                    color: #333;
                    overflow: hidden;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                }

                .unit {
                    font-size: 12px;
                    color: #666666;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }

                .price {
                    display: flex;
                    align-items: center;

                    p {
                        flex: 1;
                        font-size: 14px;
                        color: #EF1400;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }

                    span {
                        font-size: 13px;
                        color: #333;
                        white-space: nowrap;
                    }
                }
            }
        }
    }
}
</style>
